<template>
  <v-card class="card-pad mx-auto">
    <v-dialog v-model="alterDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Os dados informados não serão salvos, deseja continuar?') }}
          </div>

          <v-btn
            depressed
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="alterDialog = false"
          >
            {{ $t('Não') }}
          </v-btn>

          <v-btn
            depressed
            :loading="loading"
            class="ma-1"
            color="#B14949"
            text
            @click="closeDialog"
          >
            {{ $t('Sim') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-btn absolute top right depressed dark icon @click="close">
      <v-icon color="#bbb">mdi-close</v-icon>
    </v-btn>

    <div class="d-flex align-center justify-center my-3">
      <h2>{{ $t(currentTitle) }}</h2>
      <v-alert
        type="error"
        v-show="error"
        transition="scale-transition"
        icon="mdi-alert-octagon-outline"
      >
        {{ $t('errorMessage') }}
      </v-alert>
    </div>

    <v-window v-model="step" touchless>
      <v-window-item :value="0">
        <v-form
          class="form"
          ref="firstForm"
          v-model="firstValid"
          lazy-validation
          :disabled="institutionInactive"
        >
          <v-row class="ma-0" dense v-show="institutionInactive">
            <v-col class="py-0" cols="12">
              <InstitutionInactive />
            </v-col>
          </v-row>
          <v-row class="ma-0 mx-6" dense justify="end">
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="label ml-1">{{ $t('Equipamento') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentStandardEquipment.name"
                :rules="nameRules"
                required
                outlined
                class="primary-input"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="label ml-1">{{ $t('Sigla') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentStandardEquipment.initials"
                :rules="initialsRules"
                required
                outlined
                class="primary-input"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-text-field>
            </v-col>

            <v-col
              cols="12"
              :sm="
                fromAdmin == 1 ||
                currentStandardEquipment.workshopType == 1 ||
                currentStandardEquipment.workshopType == 'Manutenção predial'
                  ? 6
                  : 12
              "
            >
              <label class="label ml-1">{{ $t('Função') }}</label>
              <v-autocomplete
                hide-details="auto"
                v-model="currentStandardEquipment.functionEquipment"
                :items="functionsEquipment"
                :rules="[
                  (v) =>
                    this.validateFunctionEquipment(v) || 'Função requerida',
                ]"
                outlined
                class="primary-input"
              >
                <template v-slot:selection="{ item }">
                  <span class="text-caption">
                    {{ $t(item) }}
                  </span>
                </template>

                <template v-slot:item="{ item }">
                  <span class="text-caption">
                    {{ $t(item) }}
                  </span>
                </template>
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-autocomplete>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              v-if="
                currentStandardEquipment.workshopType == 1 ||
                currentStandardEquipment.workshopType == 'Manutenção predial'
              "
            >
              <label class="label ml-1">{{ $t('Oficina') }}</label>
              <v-autocomplete
                hide-details="auto"
                v-model="currentStandardEquipment.workshopId"
                :items="workshops"
                item-text="name"
                item-value="id"
                :loading="workshopsLoading"
                outlined
                class="primary-input"
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6" v-if="fromAdmin == 1">
              <label class="label ml-1">{{ $t('Oficina') }}</label>
              <v-autocomplete
                hide-details="auto"
                v-model="currentStandardEquipment.workshopType"
                :items="workshopTypes"
                :rules="[(v) => !!v || 'Oficina requerida']"
                outlined
                class="primary-input"
                :disabled="fromAdmin == 0"
              >
                <template v-slot:selection="{ item }">
                  <span class="text-caption">
                    {{ $t(item) }}
                  </span>
                </template>

                <template v-slot:item="{ item }">
                  <span class="text-caption">
                    {{ $t(item) }}
                  </span>
                </template>
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4" class="d-flex align-center justify-center">
              <v-switch
                inset
                v-model="currentStandardEquipment.calibrationSet"
                hide-details
                :label="$t('Calibração')"
                color="#bbcf20"
              ></v-switch>
            </v-col>

            <v-col cols="12" sm="4" class="d-flex align-center justify-center">
              <v-switch
                inset
                v-model="currentStandardEquipment.electricalEngineeringSet"
                hide-details
                :label="$t('Segurança elétrica')"
                color="#bbcf20"
              ></v-switch>
            </v-col>

            <v-col cols="12" sm="4" class="d-flex align-center justify-center">
              <v-switch
                inset
                v-model="currentStandardEquipment.validationQualificationSet"
                hide-details
                :label="$t('Validação / Qualificação')"
                color="#bbcf20"
              ></v-switch>
            </v-col>

            <v-col cols="12" sm="4">
              <label
                class="label ml-1"
                v-show="currentStandardEquipment.calibrationSet"
                >{{ $t('Período para Calibração') }}</label
              >
              <v-select
                v-show="currentStandardEquipment.calibrationSet"
                hide-details="auto"
                v-model="currentStandardEquipment.calibrationSchedulePeriod"
                :items="schedulePeriods"
                item-text="text"
                item-value="value"
                :rules="[(v) => !!v || 'Período requerido']"
                outlined
                class="primary-input"
              >
                <template v-slot:selection="{ item }">
                  <span class="text-caption">
                    {{ $t(item.text) }}
                  </span>
                </template>

                <template v-slot:item="{ item }">
                  <span class="text-caption">
                    {{ $t(item.text) }}
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="4">
              <label
                class="label ml-1"
                v-show="currentStandardEquipment.electricalEngineeringSet"
                >{{ $t('Período para Segurança Elétrica') }}</label
              >
              <v-select
                v-show="currentStandardEquipment.electricalEngineeringSet"
                hide-details="auto"
                v-model="
                  currentStandardEquipment.electricalEngineeringSchedulePeriod
                "
                :items="schedulePeriods"
                :rules="[(v) => !!v || 'Período requerido']"
                outlined
                item-text="text"
                item-value="value"
                class="primary-input"
              >
                <template v-slot:selection="{ item }">
                  <span class="text-caption">
                    {{ $t(item.text) }}
                  </span>
                </template>

                <template v-slot:item="{ item }">
                  <span class="text-caption">
                    {{ $t(item.text) }}
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="4">
              <label
                class="label ml-1"
                v-show="currentStandardEquipment.validationQualificationSet"
                >{{ $t('Período para Validação / Qualificação') }}</label
              >
              <v-select
                v-show="currentStandardEquipment.validationQualificationSet"
                hide-details="auto"
                v-model="currentStandardEquipment.validationSchedulePeriod"
                :items="schedulePeriods"
                item-text="text"
                item-value="value"
                :rules="[(v) => !!v || 'Período requerido']"
                outlined
                class="primary-input"
              >
                <template v-slot:selection="{ item }">
                  <span class="text-caption">
                    {{ $t(item.text) }}
                  </span>
                </template>

                <template v-slot:item="{ item }">
                  <span class="text-caption">
                    {{ $t(item.text) }}
                  </span>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="label ml-1">{{ $t('Risco') }}</label>
              <v-autocomplete
                hide-details="auto"
                v-model="currentStandardEquipment.equipmentRisk"
                :items="equipmentRisks"
                :rules="[
                  (v) => this.validateEquipmentRisk(v) || 'Risco requerido',
                ]"
                item-text="text"
                item-value="value"
                outlined
                class="primary-input"
              >
                <template v-slot:selection="{ item }">
                  <span class="text-caption">
                    {{ $t(item) }}
                  </span>
                </template>

                <template v-slot:item="{ item }">
                  <span class="text-caption">
                    {{ $t(item) }}
                  </span>
                </template>
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3" md="3" lg="3">
              <label class="label ml-1">{{ $t('Índice ABC') }}</label>
              <v-autocomplete
                hide-details="auto"
                v-model="currentStandardEquipment.indexAbc"
                :items="indexAbc"
                :rules="[
                  (v) => this.validateIndexAbc(v) || 'Índice ABC requerido',
                ]"
                outlined
                class="primary-input"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3" md="3" lg="3">
              <label class="label ml-1">Exp. Vida</label>
              <v-text-field
                hide-details="auto"
                v-model="currentStandardEquipment.lifeExpectancy"
                :rules="lifeExpectancyRules"
                type="number"
                required
                outlined
                class="primary-input"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-text-field>
            </v-col>

            <!-- <v-col cols="12" sm="6" v-if="fromAdmin == 0">
              <label class="label ml-1">Template de Analisador</label>
              <v-autocomplete
                hide-details="auto"
                v-model="
                  currentStandardEquipment.electricalSafetyAnalyserChecklistId
                "
                item-value="id"
                item-text="name"
                :items="analyserTemplates"
                :rules="[(v) => !!v || 'Template requerido']"
                outlined
                class="primary-input"
              ></v-autocomplete>
            </v-col> -->
          </v-row>
        </v-form>
      </v-window-item>

      <v-window-item :value="1">
        <div class="fill-height text-center pa-8">
          <v-icon size="60" color="success">
            mdi-checkbox-marked-circle
          </v-icon>

          <span style="display: block; margin-top: 10px; font-size: 1.2rem">
            {{
              isEditing
                ? $t('Equipamento atualizado com sucesso!')
                : $t('Equipamento cadastrado com sucesso!')
            }}
          </span>
        </div>
      </v-window-item>
    </v-window>

    <v-divider class="mb-6 mt-2 mx-8"></v-divider>

    <div class="d-flex mx-6" v-if="!institutionInactive">
      <v-btn
        depressed
        @click="close"
        v-if="step === 0"
        class="secondary-button"
      >
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        depressed
        class="primary-button mr-0"
        @click="next"
        :loading="loading"
      >
        {{ $t(buttonText) }}
      </v-btn>
    </div>
  </v-card>
</template>

<style scoped>
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

@media (max-width: 600px) {
  .v-card__text {
    padding: 0;
  }
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import InstitutionInactive from '../../Institutions/components/institutionInactive/institutionInactive.vue'

export default {
  components: {
    InstitutionInactive,
  },

  props: {
    title: String,
    standardEquipment: Object,
    fromAdmin: String,
  },

  created() {
    this.currentTitle = this.title
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionInactive = this.institution.status == 1

    // this.getTemplates()
    if (this.standardEquipment) {
      this.currentStandardEquipment = this.standardEquipment

      if (!this.isNumber(this.standardEquipment.functionEquipment)) {
        this.standardEquipment.functionEquipment =
          this.functionsEquipment.indexOf(
            this.standardEquipment.functionEquipment
          )
      }

      if (!this.isNumber(this.standardEquipment.equipmentRisk)) {
        this.standardEquipment.equipmentRisk = this.equipmentRisks.indexOf(
          this.standardEquipment.equipmentRisk
        )
      }

      if (!this.isNumber(this.standardEquipment.workshopType)) {
        this.standardEquipment.workshopType = this.workshopTypes.indexOf(
          this.standardEquipment.workshopType
        )
      }

      this.currentStandardEquipment.functionEquipment =
        this.functionsEquipment[this.standardEquipment.functionEquipment]
      this.currentStandardEquipment.equipmentRisk =
        this.equipmentRisks[this.standardEquipment.equipmentRisk]
      this.currentStandardEquipment.workshopType =
        this.workshopTypes[this.standardEquipment.workshopType]

      this.isEditing = true

      if (this.fromAdmin == 0) {
        this.currentStandardEquipment.calibrationSet =
          this.currentStandardEquipment.calibrationSet != null
            ? this.currentStandardEquipment.calibrationSet
            : this.currentStandardEquipment.standardEquipment.calibrationSet
        this.currentStandardEquipment.electricalEngineeringSet = this
          .currentStandardEquipment.electricalEngineeringSet
          ? this.currentStandardEquipment.electricalEngineeringSet
          : this.currentStandardEquipment.standardEquipment
              .electricalEngineeringSet

        this.currentStandardEquipment.validationQualificationSet =
          this.currentStandardEquipment.validationQualificationSet != null
            ? this.currentStandardEquipment.validationQualificationSet
            : this.currentStandardEquipment.standardEquipment
                .validationQualificationSet
      }
    }

    this.getWorkshops()
  },

  data: () => ({
    workshops: null,
    workshopsLoading: false,
    schedulePeriods: [
      {
        text: 'Mensal',
        value: 0,
      },
      {
        text: 'Bimestral',
        value: 1,
      },
      {
        text: 'Trimestral',
        value: 2,
      },
      {
        text: 'Semestral',
        value: 3,
      },
      {
        text: 'Anual',
        value: 4,
      },
      {
        text: 'Bianual',
        value: 5,
      },
    ],
    currentTitle: '',
    loading: false,
    step: 0,
    firstValid: true,
    alterDialog: false,
    changedData: false,
    error: false,
    errorMessage: '',
    isEditing: false,
    institutionInactive: false,
    date: null,
    institution: {},
    functionsEquipment: [
      'Acessório',
      'Análise',
      'Diagnóstico',
      'Outros equipamentos de apoio',
      'Suporte à vida',
      'Terapia',
      'Simulador/Analisador/Padrão',
    ],
    equipmentRisks: [
      'Acessório',
      'Injuria',
      'Morte',
      'Sem risco',
      'Terapia ou diagnóstico inapropriado',
    ],
    indexAbc: ['A', 'B', 'C'],
    workshopTypes: ['Engenharia clínica', 'Manutenção predial'],
    currentStandardEquipment: {
      id: 0,
      electricalEngineeringSchedulePeriod: 4,
      calibrationSchedulePeriod: 4,
      validationSchedulePeriod: 4,
      name: '',
      initials: '',
      functionEquipment: -1,
      equipmentRisk: -1,
      indexAbc: null,
      lifeExpectancy: 0,
      workshopType: null,
    },
    nameRules: [
      (v) => !!v || 'Nome requerido',
      (v) => (v && v.length <= 128) || 'Nome deve ter no máximo 128 caracteres',
    ],
    initialsRules: [
      (v) => !!v || 'Sigla requerida',
      (v) => (v && v.length <= 10) || 'Sigla deve ter no máximo 10 caracteres',
    ],
    lifeExpectancyRules: [(v) => !!v || 'Exp.Vida requerida'],

    apiService: new ApiService(),
  }),

  computed: {
    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    async getWorkshops() {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id
      this.workshopsLoading = true
      try {
        const response = await this.apiService.get(`workshop/${institutionId}`)
        this.workshops = response.content
        this.workshopsLoading = false
      } catch (error) {
        console.error('Erro ao buscar workshops:', error)
        this.workshopsLoading = false
      } finally {
        this.workshopsLoading = false
      }
    },
    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$emit('close')
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    isNumber(value) {
      return typeof value === 'number'
    },

    validateFunctionEquipment(value) {
      return this.functionsEquipment.indexOf(value) !== -1
    },

    validateEquipmentRisk(value) {
      return this.equipmentRisks.indexOf(value) !== -1
    },

    validateIndexAbc(value) {
      return this.indexAbc.indexOf(value) !== -1
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          await this.submit()
          if (!this.error) {
            this.step += 1
          }
        }
      } else {
        this.closeDialog()
      }
    },

    async submit() {
      this.loading = true

      const model = {
        StandardEquipment: {
          Id: this.currentStandardEquipment.id,
          Name: this.currentStandardEquipment.name,
          Initials: this.currentStandardEquipment.initials,
          FunctionEquipment: this.functionsEquipment.indexOf(
            this.currentStandardEquipment.functionEquipment
          ),
          EquipmentRisk: this.equipmentRisks.indexOf(
            this.currentStandardEquipment.equipmentRisk
          ),
          IndexABC: this.currentStandardEquipment.indexAbc,
          LifeExpectancy: this.currentStandardEquipment.lifeExpectancy,
          WorkshopType: this.workshopTypes.indexOf(
            this.currentStandardEquipment.workshopType
          ),
          isFromAdmin: this.fromAdmin == 1,
          CalibrationSet: this.currentStandardEquipment.calibrationSet,
          ElectricalEngineeringSet:
            this.currentStandardEquipment.electricalEngineeringSet,
          ValidationQualificationSet:
            this.currentStandardEquipment.validationQualificationSet,
          calibrationSchedulePeriod:
            this.currentStandardEquipment.calibrationSchedulePeriod,
          electricalEngineeringSchedulePeriod:
            this.currentStandardEquipment.electricalEngineeringSchedulePeriod,
          validationSchedulePeriod:
            this.currentStandardEquipment.validationSchedulePeriod,
          workshopId: this.currentStandardEquipment.workshopId,
        },
        InstitutionId: this.institution.id,
        workshopId: this.currentStandardEquipment.workshopId,
        ElectricalSafetyAnalyserChecklistId:
          this.currentStandardEquipment.electricalSafetyAnalyserChecklistId,
      }

      let url = 'standardEquipment/add'

      if (this.isEditing) {
        url = 'standardEquipment/edit'
      }

      if (this.fromAdmin == 0 && this.isEditing) {
        url = 'institutionStandardEquipment/edit'
      }

      await this.apiService
        .post(url, model)
        .then(() => {})
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.changedData = false
    },

    async remove() {
      this.loading = true

      await this.apiService
        .delete('unidade/delete', this.currentUnidade)
        .then(() => {
          this.updateTable()
          this.loading = false
          this.deleteDialog = false
        })
        .catch(() => {
          this.loading = false
          this.deleteDialog = false
        })
    },
  },

  watch: {
    currentStandardEquipment: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },
}
</script>
